import React from 'react';

const ClientStats = ({ stats, loading }) => {
  if (loading) {
    return (
      <div className="client-stats loading">
        <div className="stats-grid">
          {[...Array(4)].map((_, index) => (
            <div key={index} className="stat-card loading-card">
              <div className="stat-icon loading-shimmer"></div>
              <div className="stat-content">
                <div className="stat-number loading-shimmer"></div>
                <div className="stat-label loading-shimmer"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!stats) {
    return null;
  }

  const statCards = [
    {
      title: 'Total Tenants',
      value: stats.total_tenants,
      icon: 'building',
      color: 'blue',
      growth: stats.growth?.new_tenants,
      growthLabel: 'new this month'
    },
    {
      title: 'Active Clients',
      value: stats.active_tenants,
      icon: 'users',
      color: 'green',
      percentage: stats.total_tenants > 0 ? ((stats.active_tenants / stats.total_tenants) * 100).toFixed(1) : 0,
      percentageLabel: 'of total'
    },
    {
      title: 'Pending Requests',
      value: stats.pending_requests,
      icon: 'clock',
      color: 'orange',
      growth: stats.growth?.new_requests,
      growthLabel: 'new this month'
    },
    {
      title: 'Suspended',
      value: stats.suspended_tenants,
      icon: 'pause-circle',
      color: 'red',
      percentage: stats.total_tenants > 0 ? ((stats.suspended_tenants / stats.total_tenants) * 100).toFixed(1) : 0,
      percentageLabel: 'of total'
    }
  ];

  return (
    <div className="client-stats">
      <div className="stats-grid">
        {statCards.map((stat, index) => (
          <div key={index} className={`stat-card ${stat.color}`}>
            <div className="stat-icon">
              <i className={`fas fa-${stat.icon}`}></i>
            </div>
            
            <div className="stat-content">
              <div className="stat-number">{stat.value}</div>
              <div className="stat-label">{stat.title}</div>
              
              {stat.growth && (
                <div className="stat-growth">
                  <i className="fas fa-arrow-up"></i>
                  +{stat.growth} {stat.growthLabel}
                </div>
              )}
              
              {stat.percentage && (
                <div className="stat-percentage">
                  {stat.percentage}% {stat.percentageLabel}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Additional Stats Row */}
      <div className="additional-stats">
        <div className="stats-row">
          <div className="stat-item">
            <span className="stat-value">{stats.total_requests}</span>
            <span className="stat-desc">Total Requests</span>
          </div>
          
          <div className="stat-item">
            <span className="stat-value">{stats.approved_requests}</span>
            <span className="stat-desc">Approved</span>
          </div>
          
          <div className="stat-item">
            <span className="stat-value">{stats.rejected_requests}</span>
            <span className="stat-desc">Rejected</span>
          </div>
          
          <div className="stat-item">
            <span className="stat-value">
              {stats.total_requests > 0 ? 
                ((stats.approved_requests / stats.total_requests) * 100).toFixed(1) : 0
              }%
            </span>
            <span className="stat-desc">Approval Rate</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientStats;